import React, { useEffect } from 'react';
import styled, { ThemeProvider } from 'styled-components';

import { QuizContextProvider } from '../store/quiz';
import { Header } from '../components/Quiz/Header';
import { Steps } from '../components/Quiz/Steps';
import { heartioTheme, media, reshapeTheme } from '../utils/styles';
import { optimizeTrigger } from '../utils/logs';

const QuizPage = ({ pageContext: { uid, data } }) => {
  useEffect(() => {
    optimizeTrigger('optimize.activateOnQuizStart');
  }, []);

  const lastScreenIndex =
    data.body.length + 1 /* Age step */ + 1 /* Weight & Height step */ + 1; /* Email step */

  return (
    <ThemeProvider theme={data.heartio_styling ? heartioTheme : reshapeTheme}>
      <QuizContextProvider uid={uid} lastScreenIndex={lastScreenIndex}>
        <Wrap>
          <Header heartio={data.heartio_styling} />
          <Inner>
            <Steps data={data} uid={uid} />
          </Inner>
        </Wrap>
      </QuizContextProvider>
    </ThemeProvider>
  );
};

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  font-family: ${({ theme }) => theme.fontFamily};
  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    min-height: 100vh;
  }
`;
const Inner = styled.div`
  flex: 1;
  position: relative;
  width: 1048px;
  max-width: 100%;
  padding: 32px 20px;
  display: flex;
  justify-content: center;
  ${media.phone} {
    padding: 80px 20px 30px;
  }
`;

export default QuizPage;
